<script>
    export let color = "blueviolet";
</script>
<main>
    <div 
        class="square"
        style="background-color: {color}">
    </div>
</main>
<style>
main{
        display: flex;
        justify-content: center;
}
    .square{
        height: 200px;
        width: 200px;

    }
</style>